import { makeAutoObservable } from "mobx";
import agent from "../api/agent";
import {UserFormValues} from "../models/registration/user";
import {PageParams} from "../models/common/PagedResult";

export default class AdminStore {
    loadingInitial = false;

    constructor() {
        makeAutoObservable(this)
    }
    getAllUsers = async (params: PageParams) => {
        return await agent.Admin.getAllUsers(params);
    }

    getUser = async (userId: number) => {
        return await agent.Admin.getUser(userId);
    }
    getAllEntities = async () => {
        return agent.Admin.getAllEntities();
    }
    updateUser = async (user: UserFormValues) => {
        return await agent.Admin.updateUser(user);
    }
    
    addUserEntity= async (userId: number, entityId:number) => {
        return await agent.Admin.addUserEntity(userId, entityId);
    }
    
    deleteUserEntity= async (userId:number, entityId:number) => {
        return await agent.Admin.deleteUserEntity(userId, entityId);
    }
    getUserEntitiesById = async (userId: number)=> {
        return await agent.Admin.getUserEntitiesById(userId);
    }
    
    adduserEntityRole= async (userId:number, entityId:number, roleId:number) => {
        return await agent.Admin.addUserEntityRole(userId, entityId, roleId);
    }

    removeuserEntityRole= async (userId:number, entityId:number, roleId:number) => {
        return await agent.Admin.removeUserEntityRole(userId, entityId, roleId);
    }
}

